export function formatCurrency(cents: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('de-AT', { style: 'currency', currency }).format(cents / 100);
}

export function formatDate(timestampSeconds: number): string {
  return new Intl.DateTimeFormat('de-AT', { day: '2-digit', month: 'short', year: 'numeric' }).format(
    new Date(timestampSeconds * 1000),
  );
}

export function formatDateTime(timestampSeconds: number): string {
  return new Intl.DateTimeFormat('de-AT', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(timestampSeconds * 1000));
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('de-AT').format(value);
}

export function percentage(part: number, total: number): string {
  if (total <= 0) return '–';
  return `${new Intl.NumberFormat('de-AT', { maximumFractionDigits: 1 }).format((part / total) * 100)} %`;
}

export function toLocalDateTimeInput(date: Date): string {
  const shifted = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return shifted.toISOString().slice(0, 16);
}

export function initials(value: string): string {
  return value
    .split(/\s+/u)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
